import React, { useState, useEffect } from 'react'
import {
    CircularProgress,
    Typography,
    Button,
    Fade,
    MenuItem,
    Select,
    FormControl,
    InputLabel,
} from '@material-ui/core'
import { withRouter } from 'react-router-dom'
import axios from 'axios'
import { ValidatorForm, TextValidator } from 'react-material-ui-form-validator';
// styles
import useStyles from './styles'

function Signup(props) {
    const classes = useStyles()

    const [userValues, setUserValues] = useState({
        name: '',
        job_title: '',
        job_function: '',
        phone_cc: '+1',
        phone_no: '',
        email: '',
        password: '',
    })
    const [companyValues, setCompanyValues] = useState({
        company_name: '',
        company_size: '50',
        company_website: ''
    })

    const [isLoading, setIsLoading] = useState(false)
    const [error, setError] = useState(false)
    const [password, setPassword] = useState('')
    const [confirmPassword, setConfirmPassword] = useState('')


    useEffect(() => {
        let valid = true
        for (const key in userValues) {
            valid = !!(valid && userValues[key])
        }
        for (const key in companyValues.company) {
            valid = !!(valid && companyValues[key])
        }
    }, [])


    useEffect(() => {
        setUserValues({ ...userValues, password: password === confirmPassword ? password : '' })
    }, [confirmPassword])

    const handleUserChange = name => event => {
        setUserValues({ ...userValues, [name]: event.target.value })
    }
    const handleCompanyChange = name => event => {
        setCompanyValues({ ...companyValues, [name]: event.target.value })
    }

    const getPassword = () => {
        return password
    }
    ValidatorForm.addValidationRule('isPasswordMatch', (value) => {
        if (value !== getPassword()) {
            return false;
        }
        return true;
    });


    ValidatorForm.addValidationRule('isPhoneCC', (value) => {
        if (value.match(/^(\+?\d{1,3}|\d{1,4})$/gm)){
            return true;
        }else{
            return false;
        }
    });

    ValidatorForm.addValidationRule('isWebsite', (value) => {
        let regex = new RegExp("^(http[s]?:\\/\\/(www\\.)?|ftp:\\/\\/(www\\.)?|www\\.){1}([0-9A-Za-z-\\.@:%_\+~#=]+)+((\\.[a-zA-Z]{2,3})+)(/(.)*)?(\\?(.)*)?");
        if (value.match(regex)){
            return true;
        }else{
            return false;
        }
    });

    const submitForm = () => {
        setError('')
        setIsLoading(true)
        axios
            .post(`/api/users/signup`, { user: userValues, company: companyValues })
            .then(res => {
                setIsLoading(false)
                if (res.data.status) {
                    props.history.push('/signup/success')
                } else {
                    setError(res.message)
                }
            })
            .catch(_error => {
                // handle error
                setError('Sorry, we are unable to process your request.')
                setIsLoading(false)
            })
    }

    return (
        <ValidatorForm
            onError={errors => console.log(errors)}
            onSubmit={() => { submitForm() }}
        >
            <Typography variant='h4' className={classes.greeting}>
                Welcome!
            </Typography>
            <Typography variant='h5' className={classes.subGreeting}>
                Create your account
            </Typography>
            <Fade in={error}>
                <Typography color='secondary' className={classes.errorMessage}>
                    {error}
                </Typography>
            </Fade>
            <TextValidator
                id='companyName'
                InputProps={{
                    classes: {
                        underline: classes.textFieldUnderline,
                        input: classes.textField,
                    },
                }}
                value={companyValues.company_name}
                onChange={handleCompanyChange('company_name')}
                margin='normal'
                placeholder='Company Name'
                type='text'
                name='companyname'
                fullWidth
                validators={['required']}
                errorMessages={['this field is required']}
            />
            <FormControl className={classes.formControl}>
                <InputLabel htmlFor='companySize'>Company Size</InputLabel>
                <Select
                    value={companyValues.company_size}
                    onChange={handleCompanyChange('company_size')}
                    inputProps={{
                        name: 'companySize',
                        id: 'companySize',
                    }}
                    required
                >
                    <MenuItem value=''></MenuItem>
                    <MenuItem value='50'>50</MenuItem>
                    <MenuItem value='100'>100</MenuItem>
                    <MenuItem value='500'>500</MenuItem>
                    <MenuItem value='1000'>1000</MenuItem>
                    <MenuItem value='2000'>2000+</MenuItem>
                </Select>
            </FormControl>
            <TextValidator
                id='companyWebsite'
                InputProps={{
                    classes: {
                        underline: classes.textFieldUnderline,
                        input: classes.textField,
                    },
                }}
                value={companyValues.company_website}
                onChange={handleCompanyChange('company_website')}
                margin='normal'
                placeholder='Company Website'
                type='text'
                fullWidth
                name="website"
                validators={['required', 'isWebsite']}
                errorMessages={['this field is required', 'website url is not valid']}
            />
            <TextValidator
                id='fullName'
                InputProps={{
                    classes: {
                        underline: classes.textFieldUnderline,
                        input: classes.textField,
                    },
                }}
                value={userValues.name}
                onChange={handleUserChange('name')}
                margin='normal'
                placeholder='Your Full Name'
                type='text'
                fullWidth
                name="fullname"
                validators={['required']}
                errorMessages={['this field is required']}
            />
            <TextValidator
                id='title'
                InputProps={{
                    classes: {
                        underline: classes.textFieldUnderline,
                        input: classes.textField,
                    },
                }}
                value={userValues.job_title}
                onChange={handleUserChange('job_title')}
                margin='normal'
                placeholder='Your Title'
                type='text'
                name='title'
                fullWidth
                validators={['required']}
                errorMessages={['this field is required']}
            />
            <TextValidator
                id='designation'
                InputProps={{
                    classes: {
                        underline: classes.textFieldUnderline,
                        input: classes.textField,
                    },
                }}
                value={userValues.job_function}
                onChange={handleUserChange('job_function')}
                margin='normal'
                placeholder='Your Job Function'
                type='text'
                name='designation'
                fullWidth
                validators={['required']}
                errorMessages={['this field is required']}
            />
            <div className={classes.phoneNoHolder}>
            <TextValidator
                id='phoneNunber'
                InputProps={{
                    classes: {
                        underline: classes.textFieldUnderline,
                        input: classes.textField,
                    },
                }}
                className={classes.phoneCC}
                value={userValues.phone_cc}
                onChange={handleUserChange('phone_cc')}
                margin='normal'
                placeholder='Country Code'
                type='tel'
                name='countryCode'
                fullWidth
                validators={['required', 'isPhoneCC']}
                errorMessages={['this field is required', 'country code is not valid']}
            />
            <TextValidator
                id='phoneNumber'
                InputProps={{
                    classes: {
                        underline: classes.textFieldUnderline,
                        input: classes.textField,
                    },
                }}
                value={userValues.phone_no}
                onChange={handleUserChange('phone_no')}
                margin='normal'
                placeholder='Phone Number'
                type='phone'
                name='phonenumber'
                fullWidth
                validators={['required', 'isNumber']}
                errorMessages={['this field is required', 'only numbers are allowed']}
            />
            </div>
            
            <TextValidator
                id='email'
                InputProps={{
                    classes: {
                        underline: classes.textFieldUnderline,
                        input: classes.textField,
                    },
                }}
                value={userValues.email}
                onChange={handleUserChange('email')}
                margin='normal'
                placeholder='Email Address'
                type='email'
                name='email'
                fullWidth
                validators={['required', 'isEmail']}
                errorMessages={['this field is required', 'email is not valid']}
            />
            <TextValidator
                id='password'
                InputProps={{
                    classes: {
                        underline: classes.textFieldUnderline,
                        input: classes.textField,
                    },
                }}
                value={password}
                onChange={(e) => {
                    setPassword(e.target.value)
                }}
                margin='normal'
                placeholder='Password'
                type='password'
                name='password'
                fullWidth
                validators={['required']}
                errorMessages={['this field is required']}
            />
            <TextValidator
                id='confirmPassword'
                InputProps={{
                    classes: {
                        underline: classes.textFieldUnderline,
                        input: classes.textField,
                    },
                }}
                value={confirmPassword}
                onChange={(e) => {
                    setConfirmPassword(e.target.value)
                }}
                margin='normal'
                placeholder='Confirm Password'
                type='password'
                name='confirmPassword'
                fullWidth
                validators={['isPasswordMatch', 'required']}
                errorMessages={['password mismatch', 'this field is required']}
            />
            <div className={classes.creatingButtonContainer}>
                {isLoading ? (
                    <CircularProgress size={26} />
                ) : (
                        <Button
                            type='submit'
                            size='large'
                            variant='contained'
                            color='primary'
                            fullWidth
                            className={classes.createAccountButton}
                        >
                            Create Account
                    </Button>
                    )}
            </div>
        </ValidatorForm>
    )
}

export default withRouter(Signup)
